<div class="mo-single-toolbar">
  <div class="mo-single-toolbar-item connect-indicator">
    <tc-master-operator-connect-indicator
      [settings]="connectIndicatorSettings"
    ></tc-master-operator-connect-indicator>
  </div>
  <div
    class="mo-single-toolbar-item"
    *ngIf="masterOperatorSettings?.type == MasterOperatorType.Master"
  >
    <button
      mat-icon-button
      onclick="this.blur()"
      (click)="openNewOperatorPopup()"
      [matTooltip]="T_SCOPE + '.buttons.create-operations' | translate | lowercase"
    >
      <wlm-icon [icon]="'create-user'" [color]="color"></wlm-icon>
    </button>
  </div>
  <div
    class="mo-single-toolbar-item"
    *ngIf="masterOperatorSettings?.type == MasterOperatorType.Master"
  >
    <button
      mat-icon-button
      onclick="this.blur()"
      (click)="openRealtimePopup()"
      [matTooltip]="T_SCOPE + '.buttons.configure-realtime' | translate | lowercase"
    >
      <wlm-icon [icon]="'settings'" [color]="color"></wlm-icon>
    </button>
  </div>
  <div
    class="mo-single-toolbar-item"
    *ngIf="masterOperatorSettings?.type == MasterOperatorType.Operator"
  >
    <button
      mat-icon-button
      onclick="this.blur()"
      (click)="openOperatorPopup()"
      [matTooltip]="T_SCOPE + '.buttons.configure-operations' | translate | lowercase"
    >
      <wlm-icon [icon]="'settings'" [color]="color"></wlm-icon>
    </button>
  </div>
</div>
